module.exports = __webpack_public_path__ + "img/login-title.2cd4c5e3.png";